import { render, staticRenderFns } from "./TableData.vue?vue&type=template&id=6bb8854c&scoped=true&"
import script from "./TableData.vue?vue&type=script&lang=js&"
export * from "./TableData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb8854c",
  null
  
)

export default component.exports